module.exports = __webpack_public_path__ + "static/media/space_between.5050c427.svg";